import React from 'react';
import { CommandBarButton, IconButton } from '@fluentui/react';
import DetailsTable from '../../../../Table/DetailsTable';

const IntegratedRewardClientsTable = ({ 
    clients,
    setSelectedItem,
    loading,
    enableOnClick,
    previewOnClick,
    disableOnClick ,
}) => {
    const columns = [
            {
                minWidth: 30,
                maxWidth: 30,
                onRender: (item) => (
                    <ContextualMenu enableOnClick={enableOnClick} previewOnClick={previewOnClick} id={item.clientId} disableOnClick={disableOnClick} />
                ),
            },
            {
                name: 'ClientId',
                fieldName: 'clientId',
                minWidth: 120,
                maxWidth: 120,
                isResizable: true,
                isSorted: true,
                isSortedDescending: true,
            },
            {
                name: 'Client Name',
                fieldName: 'clientName',
                minWidth: 200,
                maxWidth: 200,
                isResizable: true,
                isSorted: true,
                isSortedDescending: true,
            },
            {
                name: 'Enabled/Disabled',
                fieldName: 'offByDefault',
                minWidth: 120,
                maxWidth: 120,
                isResizable: true,
                isSorted: true,
                isSortedDescending: true,
                onRender: (item) => item.offByDefault ? 'Disabled' : 'Enabled',
            },
        ];
    
        const items = clients ?? [];
    
        const selectionHook = (items) => {
            setSelectedItem(items && items[0] && items[0].clientId);
        };
    
        return (
            <DetailsTable
                items={items}
                columns={columns}
                selectionMode="none"
                selectionHook={selectionHook}
                loading={loading}
                mainColumn={'clientName'}
                style={{
                    position: 'relative',
                    height: '80vh',
                    width: '80vw',
                }}
            />
        );
    };
    
    const moreIcon = { iconName: 'More' };
    
    const ContextualMenu = ({ enableOnClick, disableOnClick, id, ...rest }) => {
        const menuProps = {
            items: [
                {
                    key: "Disable",
                    iconProps: { iconName: "Edit" },
                    text: "Disable By Default",
                    onClick: () => disableOnClick(id),
                },
                {
                    key: "Enable",
                    iconProps: { iconName: "Edit" },
                    text: "Enable By Default",
                    onClick: () => enableOnClick(id),
                },
            ],
        };
    
        return <IconButton iconProps={moreIcon} menuProps={menuProps} onRenderMenuIcon={() => {}} {...rest} />;
    };

export default IntegratedRewardClientsTable;
